// 动态路由插件
import store from '@/store'
let DynamicRouting = {}

DynamicRouting.install = function (Vue, router) {
  function formatRoutes(menuList = []) {
    menuList.forEach(menu=>{
      let menuPath = "/manager" + menu.path;
      // 赋值第一个跳转页面
      if(!store.getters.firstUrl) {
        if(menu.menuType === '0' && menuPath.includes('/manager/index')) {
          store.commit('setFirstUrl', menuPath)
        }
      }
      let routerConfig = {
        path: menuPath,
        name: menu.name,
        component: () => import(`@/views${menu.path}`),
        children: []
      }
      // 这里配置列表里面的子页面
      if (menu.menuType === '3') {
        router.addRoute(menu.parentName, routerConfig)
      } else {
        router.addRoute('主页', routerConfig)
      }

      if (menu.children && menu.children.length) {
        menu.children.forEach(item => {
          item.parentName = menu.name
        })
        formatRoutes(menu.children)
      }
    })
  }
  Vue.prototype.$formatRoutes = formatRoutes
}

export default DynamicRouting



// WEBPACK FOOTER //
// ./src/router/dynamic-routing.js